import styled from 'styled-components';
import { SubTitleElement } from '../text/CohortLp/CohortLpTextElements';
import { CSS_BREAKPOINTS_MIN, GUTTER_SIZE, PAPER_WHITE_COLOR } from '../../config/constants';
import SYBody16pt from '../SYBody16pt';
import SelfMasterySvg from '../../assets/svg/caleb-self-mastery.svg';
import MarleneIconSvg from '../../assets/svg/marlene-trainer.svg';
import CalebIconLearningSvg from '../../assets/svg/caleb-icon-learning.svg';

const Container = styled.section`
  text-align: center;
  padding-top: 40px;
  padding-bottom: 40px;

  @media ${CSS_BREAKPOINTS_MIN.md} {
    display: grid;
    grid-column-gap: 2em;
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${CSS_BREAKPOINTS_MIN.lg} {
    grid-column-gap: 4em;
  }
`;

const Text = styled(SYBody16pt)`
  text-align: center;
  color: ${PAPER_WHITE_COLOR};
  padding-bottom: ${GUTTER_SIZE * 2}px;
`;

const ImageSelfMastery = styled.div`
  img {
    width: 72px;
    margin-bottom: 20px;

    @media ${CSS_BREAKPOINTS_MIN.md} {
      width: 110px;
      margin-bottom: 30px;
    }
  }
`;

const ImageCaleb = styled.div`
  img {
    width: 72px;
    margin-bottom: 20px;

    @media ${CSS_BREAKPOINTS_MIN.md} {
      width: 110px;
      margin-bottom: 30px;
    }
  }
`;

const ImageLearning = styled.div`
  img {
    width: 72px;
    margin-bottom: 20px;

    @media ${CSS_BREAKPOINTS_MIN.md} {
      width: 110px;
      margin-bottom: 30px;
    }
  }
`;

const Benefit = styled.div`
  margin-bottom: ${GUTTER_SIZE * 2}px;

  @media ${CSS_BREAKPOINTS_MIN.md} {
    display: contents;

    &:first-child ${ImageSelfMastery} {
      grid-row: 1;
      grid-column: 1;
    }

    &:nth-child(2) ${ImageCaleb} {
      grid-row: 1;
      grid-column: 2;
    }

    &:last-child ${ImageLearning} {
        grid-row: 1;
        grid-column: 3;
    }

    &:first-child ${SubTitleElement} {
      grid-row: 2;
      grid-column: 1;
    }

    &:nth-child(2) ${SubTitleElement} {
      grid-row: 2;
      grid-column: 2;
    }

    &:last-child ${SubTitleElement} {
      grid-row: 2;
      grid-column: 3;
    }

    &:first-child ${Text} {
      grid-row: 3;
      grid-column: 1;
    }

    &:nth-child(2) ${Text} {
      grid-row: 3;
      grid-column: 2;
    }

    &:last-child ${Text} {
      grid-row: 3;
      grid-column: 3;
    }
  }
`;

const MarleneBenefits = () => (
  <>
    <Container>
      <Benefit>
        <ImageSelfMastery>
          <img src={SelfMasterySvg} alt="Self mastery" />
        </ImageSelfMastery>
        <SubTitleElement>A combination of Vinyasa yoga and Myo-fascial training</SubTitleElement>
        <Text>
          Learn how to apply ancient yogic practices to activate and enhance your  physical,
          emotional and spiritual fitness.
        </Text>
      </Benefit>

      <Benefit>
        <ImageCaleb>
          <img src={MarleneIconSvg} alt="Marlene Schmitt" />
        </ImageCaleb>

        <SubTitleElement>Practice with Marlene Schmitt</SubTitleElement>

        <Text>
          The Wellbeing Advocate from Berlin is an internationally trained yoga coach with many years of
          experience that she exclusively makes available to you in this course.
        </Text>
      </Benefit>

      <Benefit>
        <ImageLearning>
          <img src={CalebIconLearningSvg} alt="Learning" />
        </ImageLearning>

        <SubTitleElement>Active learning with long-term results</SubTitleElement>

        <Text>
          Follow a structured syllabus, ask questions, collaborate with your peers and coaches and receive
          effective feedback to build a personal yoga-inspired health routine that lasts.
        </Text>
      </Benefit>
    </Container>
  </>
);

export default MarleneBenefits;
